import { useEffect, useState } from 'react';
import ECGGrid from './ECGGrid';
import React from 'react';
import { LeadData, Signal } from '../../models';
import withRecordSignals, { WithRecordSignalsProps } from '../../hoc/withRecordSignals';
import RecordLeadsData from '../RecordLeadsData';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Utils from '../../../../utils/Utils';

const ECGGraph = (props: WithRecordSignalsProps) => {
  const [speed, setSpeed] = useState(25); // mm/s
  const [amplitude, setAmplitude] = useState(10); // mm/mV
  const [showGraph, setShowGraph] =  useState(false);
  const [ecgData, setEcgData] =  useState<Signal[]>([]);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  React.useEffect(() => {
        if (props.signals.length > 0) {
            setEcgData(props.signals.map(signal => ({
                ...signal,
                data: Utils.normalizeLeadDataSize(signal.sampleRate, signal.data),
            })));
            setShowGraph(true);
        }
    }, [props.signals]);

  const direction = !matches ? 'row' : 'column';
  const marginTop = '0px'; //!matches ? '40px' : '80px';

  return (
    <>
        {showGraph && <ECGGrid ecgData={ecgData} speed={speed} amplitude={amplitude} />}
    </>
  );
}

export default withRecordSignals(ECGGraph);
